export default __webpack_public_path__ + "locales/ko-KR/DeleteSelfProfileDialog.json?hash=0252fc704df302f697afb8789905c3d9";